import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { CheckInDetail, Service } from './../../interfaces/check_in';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { BranchDetail } from 'src/app/interfaces/branch';
import { DataMappingService } from 'src/app/services/data-mapping.service';
import { DatePipe } from '@angular/common'
import { PetDetail } from '../../interfaces/pet';
import { PetService } from 'src/app/services/pet.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { getCurrentDateFormatted } from 'src/app/utils/date-util'
import { logFormData } from 'src/app/utils/form-util';

@Component({
  selector: 'app-check-in-detail',
  templateUrl: './check-in-detail.component.html',
  styleUrls: ['./check-in-detail.component.scss']
})
export class CheckInDetailComponent implements OnInit {
  // @ViewChild('newModal') public newModal: ModalDirective;
  modalRef: BsModalRef;
  selectedCheckIn= {} as CheckInDetail;
  title?: string;
  closeBtnName?: string;
  isNew = false;
  checkInDetailForm: FormGroup;
  checkInDetailData = new FormData();
  checkOutData = new FormData();
  isPetsLoaded = false;
  pets= [] as PetDetail[];
  availablePets = [] as PetDetail[];
  selectedPet = {} as PetDetail;
  selectedPets = [] as PetDetail[];
  isServicesLoaded = false;
  services = [] as Service[];
  selectedServices = [] as Service[];
  availableServices = [] as Service[];
  selectedService = {} as Service;
  isSavingCheckIn = false;
  isBranchesLoaded = false;
  branchesList = [] as BranchDetail[];
  selectedBranch = {} as BranchDetail;
  isCreatingCheckOut = false;
  isCheckedOut = false;
  hasEditPermission: boolean = false;
  hasAddPermission: boolean = false;

  public onClose= new Subject<boolean>();

  constructor(
    private petService: PetService,
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    public datepipe: DatePipe,
    private router: Router,
    private dataMappingService: DataMappingService,
  ) {
    this.createPetDetailForm();
    this.checkInDetailForm = this.formBuilder.group({
      date: getCurrentDateFormatted(),
      branch: '',
      pet: '',
      service: '',
    });

    this.modalRef = bsModalRef;
    // this.getBranches();
  }

  ngOnInit(): void {
    this.checkPermissions();
    this.getBranches();
    this.getPets();
    this.getServices();
    console.log(`check-in-detail, ngOnInit, isNew: ${JSON.stringify(this.isNew)}`);
    if (!this.isNew) {
      console.log(`check-in-detail, ngOnInit, selectedCheckIn: ${JSON.stringify(this.selectedCheckIn)}`);
      this.patchCheckInDetailForm(this.selectedCheckIn);
      this.selectedPets = this.selectedCheckIn.pets;
      this.selectedBranch = this.selectedCheckIn.branch;
      this.isCheckedOut = this.selectedCheckIn.isCheckedOut;
      console.log(`check-in-detail, ngOnInit, selectedBranch: ${JSON.stringify(this.selectedBranch)}`);
      if (this.selectedCheckIn.services) {
        this.selectedServices = this.selectedCheckIn.services;
      }
    }

    this.setFormFieldsSelectedValue();

    if (!this.hasEditPermission) {
      this.disableForm();
    }
  } // end of ngOnInit

  saveCheckInDetail() {
    console.log(`saveCheckInDetail`);
    this.createCheckInDetailPayload();
    console.log(`saveCheckInDetail checkInDetailData: ${this.checkInDetailData}`);
    logFormData(this.checkInDetailData);

    if (this.isNew) {
      console.log(`saveCheckInDetail, create check in`);
      if (this.hasAddPermission) {
        this.createCheckIn();
      }
    } else {
      if (this.hasEditPermission) {
        console.log(`saveCheckInDetail, update check in`);
        this.updateCheckInDetail();
      }
    }
  } // end of saveCheckInDetail

  patchCheckInDetailForm(checkIn: CheckInDetail) {
    console.log(`patchCheckInDetailForm, this.selectedCheckIn.branch: ${JSON.stringify(this.selectedCheckIn.branch)}`);
    this.checkInDetailForm.patchValue({
      date: this.datepipe.transform(checkIn.date, 'yyyy-MM-dd'),
      branch: this.selectedCheckIn.branch,
      // pet: checkIn.pet.name,
      pet: '',
      service: '',
    });
  } // end of patchCheckInDetailForm

  updateCheckInDetail() {
    this.isSavingCheckIn = true;
    console.log(`updateCheckInDetail, petDetailData:${this.checkInDetailData}`);
    this.petService.updateCheckIn(this.selectedCheckIn.id, this.checkInDetailData).subscribe({
      next: (response) => {
        this.isSavingCheckIn = false;
        console.log(`updateCheckInDetail, response: ${JSON.stringify(response)}`);
        this.hideModal(true);
      },
      error: (error) => {
        this.isSavingCheckIn = false;
        console.error(`updateCheckInDetail, error: ${JSON.stringify(error)}`);
      }
    });
    this.isSavingCheckIn = false;
  } // end of updateCheckInDetail

  createCheckIn() {
    this.isSavingCheckIn = true;
    console.log(`createCheckIn, petDetailData:${JSON.stringify(this.checkInDetailData)}`);
    this.petService.createCheckIn(this.checkInDetailData).subscribe({
      next: (response) => {
        this.isSavingCheckIn = false;
        console.log(`createCheckIn, response: ${JSON.stringify(response)}`);
        this.hideModal(true)
      },
      error: (error) => {
        this.isSavingCheckIn = false;
        console.error(`createCheckIn, error: ${JSON.stringify(error)}`);
        this.hideModal(false)
      }
    });
    this.isSavingCheckIn = false;
  } // end of createCheckIn


  createPetDetailForm() {
    this.checkInDetailForm = this.formBuilder.group({
      date: '',
      branch: '',
      pet: '',
      service: '',
    });
  } // end of createPetDetailForm

  getPets() {
    this.isPetsLoaded = false;
    this.petService.getPets().subscribe({
      next: (response) => {
        console.log(`getPets, response: ${JSON.stringify(response)}`);
        this.pets = this.dataMappingService.mapPetsDetailDataToInterfaces(response);
        // Refresh available Pets
        this.getAvailablePets();
        this.isPetsLoaded = true;
      },
      error: (error) => {
        this.isPetsLoaded = true;
        console.error(`getOwners, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of getPets

  // getAvailablePets() {
  //   this.availablePets = this.pets.filter(pet => pet.id != this.selectedPet.id);
  // } // end of getAvailablePets

  getAvailablePets() {
    let tempPets = this.pets;
    for (var pet of this.selectedPets) {
      console.log(`getAvailablePets, pet: ${JSON.stringify(pet)}`);
      tempPets = tempPets.filter(item => item.id != pet.id);
    }
    console.log(`getAvailablePets, tempPets: ${JSON.stringify(tempPets)}`);
    this.availablePets = tempPets;
  } // end of getAvailablePets

  getServices() {
    this.isServicesLoaded = false;
    this.petService.getServices().subscribe({
      next: (response) => {
        console.log(`getServices, response: ${JSON.stringify(response)}`);
        this.services = response;
        this.getAvailableServices();
        this.isServicesLoaded = true;
      },
      error: (error) => {
        this.isServicesLoaded = true;
        console.error(`getServices, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of getServices

  getAvailableServices() {
    let tempServices = this.services;
    for (var service of this.selectedServices) {
      console.log(`getAvailableService, service: ${JSON.stringify(service)}`);
      tempServices = tempServices.filter(item => item.id != service.id);
    }
    console.log(`getAvailableVaccines, tempServices: ${JSON.stringify(tempServices)}`);
    this.availableServices = tempServices;
  } // end of getAvailableServices

  onSelectPet (event: TypeaheadMatch): void{
    this.selectedPet = event.item;
    this.selectedPets.push(event.item);
    console.log(`onSelectPet, selectedPet:${this.selectedPet.name}`);
    // Refresh available Pets
    this.getAvailablePets();
    // Reset pet name control
    this.resetPetNameControl();
  } // end of onSelectPet

  onSelectService (event: TypeaheadMatch): void{
    this.selectedService = event.item;
    console.log(`onSelectService, selectedService:${this.selectedService.name}`);
    this.selectedServices.push(this.selectedService);
    // Refresh available services
    this.getAvailableServices();
    // Reset service name control
    this.resetServiceNameControl();
  } // end of onSelectService

  createCheckInDetailPayload() {
    this.checkInDetailData.set('date', this.checkInDetailForm.controls['date'].value);
    this.checkInDetailData.set('branch_id', this.selectedBranch.id);
    this.createSelectedPetsPayload();
    // this.checkInDetailData.set('PetId', this.selectedPet.id);
    // Add services ID to payload
    this.createSelectedServicesPayload();
  } // end of createCheckInDetailPayload

  createSelectedServicesPayload(): void {
    for (let i = 0; i < this.selectedServices.length; i++) {
      this.checkInDetailData.append('services', this.selectedServices[i].id);
    }
  } // end of createSelectedServicesPayload

  createSelectedPetsPayload(): void {
    this.selectedPets.forEach(p => {
      console.log(`createSelectedPetsPayload, pet id: ${p.id}`)
      this.checkInDetailData.append('pet_ids', p.id);
    });
    // for (let i = 0; i < this.selectedPets.length; i++) {
    //   this.checkInDetailData.append('pet_id', this.selectedPets[i].id);
    // }
  } // end of createSelectedPetsPayload

  deleteService(service: Service) {
    console.log(`deleteService, service:${service.id}`);
    this.selectedServices = this.selectedServices.filter(item => item.id != service.id);
    console.log(`deleteService, selectedServices:${JSON.stringify(this.selectedServices)}`);
    // Refresh available services
    this.getAvailableServices();
  } // end of deleteService

  hideModal(result: boolean) {
    this.onClose.next(true);
    this.bsModalRef.hide();
  } // end of hideModal

  closeModal() {
    this.hideModal(false);
  } // end of hideModal

  // checkOut() {
  //   this.hideModal(true);
  //   this.router.navigate(['check-out']);
  // }

  createCheckOut() {
    this.createCheckOutPayload();
    this.isCreatingCheckOut = true;
    logFormData(this.checkOutData);
    this.petService.createCheckOut(this.checkOutData).subscribe({
      next: (response) => {
        this.isCreatingCheckOut = false;
        console.log(`createCheckOut, response: ${JSON.stringify(response)}`);
        this.hideModal(true)
        this.router.navigate(['check-out']);
      },
      error: (error) => {
        this.isCreatingCheckOut = false;
        console.error(`createCheckOut, error: ${JSON.stringify(error)}`);
        this.hideModal(false)
      }
    });
    this.isCreatingCheckOut = false;
  } // end of createCheckOut

  getBranches() {
    this.isBranchesLoaded = false;
    this.petService.getBranches().subscribe({
      next: (response) => {
        console.log(`getBranches, response: ${JSON.stringify(response)}`);
        this.branchesList = response;
        this.selectedBranch = this.branchesList[0];

        if (!this.isNew) {
          console.log(`getBranches, Not new`);
          this.selectedBranch = this.branchesList.filter(b => b.id==this.selectedCheckIn.branch.id)[0];
        }

        console.log(`getBranches, selectedBranch: ${JSON.stringify(this.selectedBranch)}`);
        this.checkInDetailForm.get('branch')?.setValue(this.selectedBranch);
        this.isBranchesLoaded = true;
      },
      error: (error) => {
        this.isBranchesLoaded = true;
        console.error(`getBranches, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of getBranches

  setFormFieldsSelectedValue() {
    this.checkInDetailForm.get('branch')?.valueChanges.subscribe(value => {
      console.log(`branch chang, value: ${JSON.stringify(value)}`);
      this.selectedBranch = value;
      console.log(`petRegisterForm chang, value: ${value}, selectedBranch: ${JSON.stringify(this.selectedBranch)}`);
    });
  }

  deleteSelectedPet(pet: PetDetail) {
    console.log(`deleteSelectedPet, pet: ${JSON.stringify(pet)}`);
    const tempSelectedPets = this.selectedPets.filter(p => p.id !== pet.id);
    this.selectedPets = tempSelectedPets;
    // Refresh available Pets
    this.getAvailablePets();
  }

  resetPetNameControl() {
    this.checkInDetailForm.controls['pet'].setValue('');
  }

  resetServiceNameControl() {
    this.checkInDetailForm.controls['service'].setValue('');
  }

  createCheckOutPayload() {
    this.checkOutData.set('date', getCurrentDateFormatted());
    this.checkOutData.set('check_in_id', this.selectedCheckIn.id);
  } // end of createCheckOutPayload

  checkPermissions(){
    this.hasEditPermission = this.petService.hasPermission('api.change_checkin');
    console.log(`CheckInComponent, hasEditPermission: ${this.hasEditPermission}`);
    this.hasAddPermission = this.petService.hasPermission('api.add_checkin');
    console.log(`CheckInComponent, hasAddPermission: ${this.hasAddPermission}`);
  }

  disableForm(){
    if (!this.hasEditPermission) {
      this.checkInDetailForm.disable(); 
    }
  }
}
